import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

// 定义左侧标签类型
export type LeftSidebarTab = "content" | "template" | "style" | "novaai";

type Sheet = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

type PanelHandle = {
  isDragging: boolean;
  setDragging: (dragging: boolean) => void;
};

type Panel = {
  size: number;
  setSize: (size: number) => void;
  handle: PanelHandle;
};

type BuilderState = {
  // 当前激活的左侧标签
  activeLeftTab: LeftSidebarTab;

  frame: {
    ref: HTMLIFrameElement | null;
    setRef: (ref: HTMLIFrameElement | null) => void;
    handleZoomIn: () => void;
    handleZoomOut: () => void;
    handleResetView: () => void;
    handleCenterView: () => void;
  };
  sheet: {
    left: Sheet;
    right: Sheet;
  };
  panel: {
    left: Panel;
    right: Panel;
  };
};

type BuilderActions = {
  // 设置当前激活的左侧标签
  setActiveLeftTab: (tab: LeftSidebarTab) => void;
  toggle: (side: "left" | "right") => void;
};

export const useBuilderStore = create<BuilderState & BuilderActions>()(
  immer((set) => ({
    // 默认激活内容编辑标签
    activeLeftTab: "content",

    frame: {
      ref: null,
      setRef: (ref) => {
        set((state) => {
          // @ts-expect-error Unable to set ref type
          state.frame.ref = ref;
        });
      },
      handleZoomIn: () => {
        // Placeholder
      },
      handleZoomOut: () => {
        // Placeholder
      },
      handleResetView: () => {
        // Placeholder
      },
      handleCenterView: () => {
        // Placeholder
      },
    },
    sheet: {
      left: {
        open: false,
        setOpen: (open) => {
          set((state) => {
            state.sheet.left.open = open;
          });
        },
      },
      right: {
        open: false,
        setOpen: (open) => {
          set((state) => {
            state.sheet.right.open = open;
          });
        },
      },
    },
    panel: {
      left: {
        size: 0,
        setSize: (size) => {
          set((state) => {
            state.panel.left.size = size;
          });
        },
        handle: {
          isDragging: false,
          setDragging: (dragging) => {
            set((state) => {
              state.panel.left.handle.isDragging = dragging;
            });
          },
        },
      },
      right: {
        size: 0,
        setSize: (size) => {
          set((state) => {
            state.panel.right.size = size;
          });
        },
        handle: {
          isDragging: false,
          setDragging: (dragging) => {
            set((state) => {
              state.panel.right.handle.isDragging = dragging;
            });
          },
        },
      },
    },
    // 标签切换动作
    setActiveLeftTab: (tab) => {
      set((state) => {
        state.activeLeftTab = tab;
      });
    },
    toggle: (side) => {
      set((state) => {
        state.sheet[side].open = !state.sheet[side].open;
      });
    },
  })),
);
